import React, { FC, useState } from 'react'
import { PageURLs } from '../../common'
import PinImage from '../../images/pin.svg'
import { Link, useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { startNewTransfer } from '../../store/slices/app'
import useAirportLookup, { TravelPayoutAutocompleteResult } from '../../hooks/useAirportLookup'

interface Props {
  size: 'large' | 'small'
}

const BookNowForm: FC<Props> = ({ size }) => {
  const [query, setQuery] = useState('')
  const [showResults, setShowResults] = useState(false)
  const [result, setResult] = useState<TravelPayoutAutocompleteResult | undefined>(undefined)
  const history = useHistory()
  const dispatch = useDispatch()
  const { results, getAirportName } = useAirportLookup(query, showResults)

  const handleBookNow = () => {
    if (result) {
      dispatch(
        startNewTransfer({
          airport_name: getAirportName(result),
          airport_code: result.code,
          airport_country: result.country_code,
          airport_lat: result.coordinates.lat,
          airport_lng: result.coordinates.lon,
        })
      )
    }

    history.push(PageURLs.BookNow)
  }

  const handleAirportSelect = (result: TravelPayoutAutocompleteResult) => {
    setQuery(getAirportName(result))
    setShowResults(false)
    setResult(result)
  }

  return (
    <div className="row">
      <div className="col-12 mt-3">
        <div className={`book-now-form-wrap bg-white p-4 p-lg-5 position-relative ${size === 'large' ? 'has-bg' : ''}`}>
          <div className="row">
            <div className={size === 'large' ? 'col-11 col-lg-9' : 'col-12'}>
              <div className="input-group bg-white input-group-lg position-relative">
                <div className="d-flex flex-grow-1 position-relative">
                  <img src={PinImage} alt="Book Now" className="pin-arrow" />

                  <input
                    type="text"
                    className="form-control form-control-lg pl-5 h-full"
                    placeholder="Which Airport?"
                    value={query}
                    onChange={(event) => {
                      setShowResults(true)
                      setQuery(event.target.value.trim())
                    }}
                  />
                  {showResults && results.length > 0 && (
                    <div className="airport-results-wrap position-absolute bg-white d-flex flex-column w-100 z-index-9 py-3">
                      {results.map((result: TravelPayoutAutocompleteResult) => (
                        <span className="px-3 py-1" key={result.id} onClick={() => handleAirportSelect(result)}>
                          {getAirportName(result)} ({result.code})
                        </span>
                      ))}
                    </div>
                  )}
                </div>

                <div className="input-group-append greetings-btn-group">
                  <Link
                    onClick={handleBookNow}
                    to="/book-now/"
                    className={`btn btn-primary border border-secondary ${size === 'large' ? 'px-5' : ''}`}
                  >
                    Book Now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BookNowForm
